// extracted by mini-css-extract-plugin
export default {"minOrder":"MinOrder_minOrder__oW3-4"};